import React from "react";
import { isEmpty } from "lodash";
import { Container, Grid, Label, Button } from "semantic-ui-react";
import CustomSearch from "../../shared/CustomSearch";

class Buscadores extends React.Component {
  state = {
    idColegio: null,
    idActividad: null,
    busquedaColegio: "",
    busquedaActividad: ""
  };

  handleSearchFieldAction = (field, { busqueda }) => {
    !isEmpty(busqueda) &&
      this.props.handleSearchFieldAction({
        field,
        busqueda
      });
  };

  handleSelectColegio = idColegio => {
    this.setState({ idColegio, busquedaColegio: "" });
    this.props.onColegioSelect(idColegio);
  };

  handleSelectActividad = idActividad => {
    this.setState({ idActividad, busquedaActividad: "" });
    this.props.onActividadSelect(idActividad);
  };

  handleButtonClick = () => {
    const { idColegio, idActividad } = this.state;
    this.props.handleSearch({ idColegio, idActividad });
  };

  render() {
    return (
      <Container>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Label content="Búsqueda de Colegios" basic size="big" />
              <CustomSearch
                fluid
                iconPosition="left"
                id="buscarColegio"
                name="busqueda"
                type="text"
                datosBusqueda={this.props.searchDataColegios}
                onSelect={this.handleSelectColegio}
                value={this.state.busquedaColegio}
                icon="search"
              />
            </Grid.Column>

            <Grid.Column>
              <Label content="Búsqueda de Actividades" basic size="big" />
              <CustomSearch
                fluid
                iconPosition="left"
                id="buscarActividad"
                name="busqueda"
                type="text"
                datosBusqueda={this.props.searchDataActividades}
                onSelect={this.handleSelectActividad}
                value={this.state.busquedaActividad}
                icon="search"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered>
            <Button
              fluid
              color="pink"
              onClick={this.handleButtonClick}
              disabled={this.props.buttonDisabled}
            >
              Filtrar
            </Button>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default Buscadores;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoCobros/Buscadores.jsx